import React from "react";
import { FiSearch, FiX } from "react-icons/fi";

const SearchBar = ({ value, setValue, onSearch,onClear }) => {
  const handleKeyPress = (e) => {
    if (e.key === "Enter") onSearch(value);
  };

  const clearValue = () => {
    setValue("");
  };

  return (
    <div className="flex items-center border border-quaternary/60 rounded-lg px-3 py-2 w-full max-w-md bg-white shadow-sm focus-within:ring-1 focus-within:ring-quaternary transition-all">
      {/* Input field */}
      <input
        type="text"
        placeholder="Search..."
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyPress}
        className="promo flex-1 outline-none text-gray-700 placeholder-gray-400 bg-transparent"
      />

      {/* Clear icon */}
      {value && (
        <button
          onClick={onClear}
          title="Click to clear search"
          className="text-orange hover:text-orange/40 transition-colors mr-1"
        >
          <FiX size={18} />
        </button>
      )}

      {/* Search button */}
      <button
        onClick={() => onSearch(value)}
        title="Click to search"
        className={`ml-1 ${
          value
            ? "text-quaternary hover:text-orange transition-colors"
            : "cursor-not-allowed pointer-events-none text-gray"
        }`}
      >
        <FiSearch size={20} />
      </button>
    </div>
  );
};

export default SearchBar;
